export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Club |||| Clubs",
      forcedCaseName: "Club",
      fields: {
        name: "Club name",
        is_client: "Client",
        website: "Website",
        email: "Email",
        social_links: "Social media",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of judges-referees",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your club list is empty.",
        title: "No clubs found",
      },
      field_categories: {
        contact: "Club info",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Club",
        edit: "Edit club",
        new: "New Club",
        show: "Show club",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No judge-referee",
      nb_contacts:
        "%{smart_count} judge-referee |||| %{smart_count} judges-referees",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the club",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new club",
      },
      merge: {
        action: "Merge with another club",
        confirm: "Merge Clubs",
        current_contact: "Current Club (will be deleted)",
        description: "Merge this club with another one.",
        error: "Failed to merge clubs",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a club to merge with",
        success: "Clubs merged successfully",
        target_contact: "Target Club (will be kept)",
        title: "Merge Club",
        warning_description:
          "All data will be transferred to the second club. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        only_mine: "Only clubs I manage",
      },
    },
    contacts: {
      // Short form here (not "Judge-Referee"): fits the fixed-width mobile
      // bottom nav. See adr/ADR-66f03297-TASK-001-contacts-nav-label-fallback.md
      name: "Referee |||| Referees",
      forcedCaseName: "Referee",
      field_categories: {
        address: "Address",
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
        case_info: "Case info",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Club",
        referred_by_id: "Referred by",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        amount: "Budget",
        description: "Case description",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
        gender: "Gender",
        status: "Status",
        tags: "Tags",
        nb_tasks: "Tasks",
        first_seen: "First seen",
        latest_note_text: "Latest note",
        name: "Name",
        postal_code: "Postal code",
        city: "City",
      },
      action: {
        add: "Add judge-referee",
        add_first: "Add your first judge-referee",
        create: "Create judge-referee",
        edit: "Edit judge-referee",
        export_vcard: "Export to vCard",
        new: "New Judge-Referee",
        show: "Show judge-referee",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your judge-referee list is empty.",
        title: "No judges-referees found",
      },
      import: {
        title: "Import judges-referees",
        button: "Import CSV",
        complete:
          "Judges-referees import complete. Imported %{importCount} judges-referees, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} judges-referees, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "judge-referee |||| judges-referees",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading judges-referees",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected judges-referees.",
        description:
          "Choose an existing tag or create a new one for the selected judges-referees.",
        empty: "No tags yet. Create one to tag the selected judges-referees.",
        error: "Failed to add tag to judges-referees",
        noop: "Selected judges-referees already have this tag",
        success:
          "Tag added to %{smart_count} judge-referee |||| Tag added to %{smart_count} judges-referees",
        title: "Add tag to judges-referees",
      },
      merge: {
        action: "Merge with another judge-referee",
        confirm: "Merge Judges-Referees",
        current_contact: "Current Judge-Referee (will be deleted)",
        description: "Merge this judge-referee with another one.",
        error: "Failed to merge judges-referees",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a judge-referee to merge with",
        success: "Judges-Referees merged successfully",
        target_contact: "Target Judge-Referee (will be kept)",
        title: "Merge Judge-Referee",
        warning_description:
          "All data will be transferred to the second judge-referee. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        // Mirrors the Kanban column sort / countdown chip's "needs action"
        // rule (next action overdue or due today).
        needs_action: "To handle",
        search: "Search name, club...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a judge-referee by adding a note to that judge-referee and clicking on "show options".',
        empty_hint: 'Judges-referees with a "Visio" status will appear here.',
        title: "Hot Prospects",
      },
      other_judges_notes:
        "Notes from other judges-referees |||| Notes from other judges-referees",
      other_judges_notes_empty: "No notes from these judges-referees yet.",
      other_judges_notes_view_profile: "View profile",
      other_judges_notes_more:
        "+ %{smart_count} more note on their profile |||| + %{smart_count} more notes on their profile",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Judge-Referee",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a judge-referee's page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
      editor: {
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        heading: "Heading",
        bullet_list: "Bullet list",
        ordered_list: "Numbered list",
        link: "Link",
        formatting: "Formatting",
      },
      next_action: {
        title: "Dated next action",
        create: "Create a task",
        existing: "Choose an open task",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        disabled: "Disabled",
        password: "Temporary password",
      },
      create: {
        error: "An error occurred while creating the user.",
        success: "User created with a temporary password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        password_reset: "Temporary password reset successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Judge-Referee",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your judges-referees will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      assigned_to_me: "Assigned to me",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    clients: {
      title: "Clients",
      empty: "No clients found",
      referees: "Judges-referees",
      no_referees: "No judges-referees linked",
      add_referee: "Add a judge-referee",
      remove_referee: "Remove link",
      remove_confirm:
        "Remove this judge-referee and its checklist from this club?",
      search_referee: "Search contacts",
      import_followups: "Judge-referee progress",
      checklist: {
        edit: "Edit steps",
        back: "Back to clients",
        shared_description: "For all clients",
        progress_compact: "%{completed}/%{total}",
        progress: "%{completed} / %{total} completed",
        progress_label: "Client checklist progress",
        completed: "Complete",
        settings_title: "Follow-up steps",
        club_title: "Club steps",
        referee_title: "Judge-referee steps",
        club_description: "For all client clubs",
        referee_description: "For each linked judge-referee",
        empty: "No steps defined",
        name: "Step name",
        save: "Save checklist",
        saved: "Checklist saved",
        save_error: "Unable to save the checklist",
      },
    },
    follow_up: {
      other_notes: "Other notes",
      title: "Follow-up",
      open_tasks: "Next actions",
      no_open_tasks: "No open actions",
      history: "History",
      empty_history: "No notes or completed tasks",
      load_more: "Load more",
    },
    changelog: {
      title: "Changelog",
    },
    map: {
      title: "Map",
      empty: "No contact could be located on the map.",
    },
    activity: {
      added_company: "%{name} added club",
      you_added_company: "You added club",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      amount_chart: "Upcoming Amount",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    // Namespace for the contacts Kanban toggle and its countdown chip
    // (TASK-004) -- not scoped to `resources.contacts` since it may back
    // another entity's Kanban later.
    kanban: {
      view_table: "Table",
      view_kanban: "Kanban",
      next_action_due: {
        overdue: "Overdue",
        today: "Due today",
        tomorrow: "Due tomorrow",
        in_days: "%{smart_count}d",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint:
        "Drop a file to upload, click to select it, or paste an image (Ctrl+V).",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, clubs, judges-referees, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
        visible_in_kanban: "Visible in Kanban",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding judges-referees.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
